export default function Table(theme) {
  return {
    MuiTableContainer: {
      styleOverrides: {
        root: { boxShadow: 'none' },
      },
    },
    MuiTable: {
      styleOverrides: {
        root: {
          '& .MuiTableRow-hover:hover': {
            backgroundColor: theme.palette.grey[100],
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            color: theme.palette.text.secondary,
            backgroundColor: theme.palette.grey[100],
            fontWeight: 600,
            fontSize: theme.typography.pxToRem(12),
            textTransform: 'uppercase',
            letterSpacing: '0.04em',
            borderBottom: `1px solid ${theme.palette.grey[200]}`,
          },
          '& .MuiTableCell-head:first-of-type': {
            borderTopLeftRadius: 0,
          },
          '& .MuiTableCell-head:last-of-type': {
            borderTopRightRadius: 0,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          fontSize: theme.typography.pxToRem(13.5),
          paddingTop: theme.spacing(1.5),
          paddingBottom: theme.spacing(1.5),
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:last-child .MuiTableCell-root': {
            borderBottom: 'none',
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.lighter,
            '&:hover': { backgroundColor: theme.palette.primary.lighter },
          },
        },
      },
    },
  };
}
